import React from 'react'

function Leads() {
  return (
    <div>
      
    </div>
  )
}

export default Leads
